import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-top",
  "use": "icon-top-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-top\">\n\n <g>\n  <title>background</title>\n  <rect fill=\"none\" id=\"icon-top_canvas_background\" height=\"402\" width=\"582\" y=\"-1\" x=\"-1\" />\n </g>\n <g>\n  <title>Layer 1</title>\n  <path stroke=\"null\" id=\"icon-top_svg_1\" d=\"m562.428427,12.099771a95.419645,95.419645 0 0 1 31.265842,31.234025l114.439956,186.004704l217.779431,0c52.70346,0 95.419645,46.437551 95.419645,103.689337l0,587.785012c0,57.251787 -42.716184,103.689352 -95.419645,103.689352l-826.970245,0c-52.70346,0 -95.419645,-46.437565 -95.419645,-103.689352l0,-587.785012c0,-57.251787 42.716184,-103.689337 95.419645,-103.689337l217.747629,0l114.471757,-186.004704a95.419645,95.419645 0 0 1 131.26563,-31.265827l0,0.031802zm140.839396,662.530395l-540.711325,0l0,95.419645l540.711325,0l0,-95.419645zm159.032746,-222.645833l-699.744072,0l0,95.419645l699.744072,0l0,-95.419645zm-349.872036,-358.650643l-83.683028,136.00481l167.366057,0l-83.683028,-136.00481z\" />\n </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/top.svg
// module id = jE4f
// module chunks = 104